import NProgress from 'nprogress';
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_ATS_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import { toast } from 'react-toastify';

export const GetCtcCategoryHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/ats/ancillary/getCtcCategory`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const AddCtcCategoryHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ats/ancillary/addCtcCategory`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            min_range: params?.min_range,
            max_range: params?.max_range,
            ctc_category_label: params?.category_label,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("CTC category added successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateCtcCategoryHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...")
    return await axiosInstance(`/ats/ancillary/updateCtcCategory`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            min_range: params?.min_range,
            max_range: params?.max_range,
            ctc_category_label: params?.category_label,
            ctc_category_configuration_pk: params?.ctc_category_configuration_pk
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("CTC category updated successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteCtcCategoryHelper = async (params) => {
    toast.info("Deleting...")
    return await axiosInstance(`/ats/ancillary/deleteCtcCategory`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            ctc_category_configuration_pk: params?.ctc_category_configuration_pk,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("CTC category Deleted successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}